import { useQuery } from "react-query";
import { axiosInstance } from "@src/api/axiosConfig";
import { axiosPath } from "@src/api/axiosPath";
import { KakaoFriendListFilterType, KakaoFriendListResponse } from "./types";

export const initKakaoFriendListFilters: KakaoFriendListFilterType = {
    page: 1,
    limit: 10,
};

// 카톡 친구 리스트 조회
const fetchKakaoFriendList = async (): Promise<KakaoFriendListResponse> => {
    const response = await axiosInstance.get(axiosPath.kakaoFriends);

    return response.data;
};

export const useKakaoFriendList = () => {
    return useQuery<KakaoFriendListResponse, Error>(
        ["kakaoFriendList"],
        () => fetchKakaoFriendList(),
        { keepPreviousData: true },
    );
};
